/* eslint-disable */
import {CustomerPageMenuItem} from './CustomerPageMenuItem';
import {CustomerPageSection} from './CustomerPageSection';
import {CustomerOrder} from './CustomerOrder';
import {FavouritesListviewProduct} from './FavouritesListviewProduct';
import {ProductlistViewProduct} from './ProductlistViewProduct';
import {CustomerPageUser} from './CustomerPageUser';
import {BasePageModel} from './BasePageModel';
/**
* @description Interface for Avensia.Commerce.Web.Models.CustomerPage.CustomerPageModel
*/
export interface CustomerPageModel extends BasePageModel {
	returnsPageUrl?: string;
	claimsPageUrl?: string;
	deliveryPageUrl?: string;
	paymentPageUrl?: string;
	changesPageUrl?: string;
	rentalPageUrl?: string;
	shippingDamagePageUrl?: string;
	priceMatchPageUrl?: string;
	loginPage: string;
	menuItems: CustomerPageMenuItem[];
	loginPageMenuItems: CustomerPageMenuItem[];
	section: CustomerPageSection;
	orders?: CustomerOrder[];
	pendingOrders?: CustomerOrder[];
	totalOrdersCount?: number;
	ordersPerPage?: number;
	favouritesList?: FavouritesListviewProduct[];
	basedOnFavourites?: ProductlistViewProduct[];
	customer?: CustomerPageUser;
	message?: string;
	hash?: string;
	email?: string;
	userId?: string;
	orderNumber?: string;
}
export const isCustomerPage = (model: unknown): model is CustomerPageModel => (model as CustomerPageModel).componentName === 'CustomerPage';
